import type { AppEnvironment } from './environment.model';

export const environment: AppEnvironment = {
    production: false,
    appUrl: 'https://app.pento.mx',
    apiUrl: 'https://pento-api-484803948824.us-central1.run.app',
    keycloakUrl: 'https://keycloak-484803948824.us-central1.run.app/realms/pento-prod',
    clientId: 'pento-app-client',
    clientSecret: undefined,
    redirectUri: window.location.origin + '/callback',
    scopes: 'openid profile email',
    publicStorageBaseUrl: 'https://storage.googleapis.com/pento-public-prod',
    netpayCdnUrl: 'https://docs.netpay.mx/cdn/v1.3/netpay.min.js',
    netpay3dsCdnUrl: 'https://cdn.netpay.mx/js/latest/netpay3ds.js',
    /** Sustituir por la llave pública de producción en el despliegue. */
    netpayPublicKey: '',
    netpaySandboxMode: false
};
